import { render, staticRenderFns } from "./Echipe.vue?vue&type=template&id=bdd92092&scoped=true"
import script from "./Echipe.vue?vue&type=script&lang=js"
export * from "./Echipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd92092",
  null
  
)

export default component.exports